import { render, staticRenderFns } from "./OperaWithdrawRecordWindow.vue?vue&type=template&id=6653211c&scoped=true&"
import script from "./OperaWithdrawRecordWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWithdrawRecordWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaWithdrawRecordWindow.vue?vue&type=style&index=0&id=6653211c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653211c",
  null
  
)

export default component.exports